import { Modal } from 'antd';
import React, { CSSProperties, ReactNode } from 'react';

const CustomModal = ({
    title,
    isModalOpen,
    open,
    handleOk,
    onClose,
    subTitle,
    hideCloseIcon,
    children,
    showFooter = false,
    maxWidth,
    styles
}: {
    maxWidth?: string;
    title?: string;
    handleOk?: () => void;
    onClose: (refreshList?: boolean) => void;
    isModalOpen?: boolean;
    open?: boolean;
    children: ReactNode;
    subTitle?: ReactNode;
    hideCloseIcon?: boolean;
    showFooter?: boolean;
    styles?: CSSProperties;
}) => {
    return (
        <Modal
            title={title}
            open={isModalOpen || open}
            onOk={handleOk}
            onCancel={() => onClose()}
            closable={!hideCloseIcon}
            footer={showFooter}
            style={{
                maxWidth,
                borderRadius: 16,
                padding: 0,
                ...styles,
                zIndex: 3000
            }}
            centered
            className='custom-ant-modal'
        >
            <div className='relative w-full overflow-hidden rounded-[16px]'>
                {subTitle && <p className='mb-4 px-4'>{subTitle}</p>}
                <div>{children}</div>
            </div>
        </Modal>
    );
};

export default CustomModal;
